<app-dashboard-admin style="width: inherit;"></app-dashboard-admin>
<section style="background: #f1f1f1; padding-bottom: 4%;">
    <section class="section-css">
        <div class="row">
            <div class="col-sm" style="height: 10px;"></div>
            <div class="col-md" style="height: 20px"></div>
        </div>

        <div class="topnav">
            <a routerLink="/dashboardmain-admin"><i class="fa fa-home" aria-hidden="true"></i></a>
            <a style="color: #6c757d;text-decoration: none;">Manage Return Tax ><span
                    style="color: #337ab7;font-family: 'pt_sans_captionbold';"> Manage Return Tax </span></a>
        </div>
    </section>
    <br>
    <div id="grid" class="grid-styles">
        <dx-data-grid id="grid-container" [dataSource]="mnge_rtn_tx_lst" [showBorders]="true"
            (onSelectionChanged)="selectionChanged($event)" style="max-width: 100%;" 
            class="grid-table-styles" href="{$event.key.fileName}" (onRowClick)="downloadFile($event)" > 
            
            
            <dxo-editing mode="form"></dxo-editing>
            <dxo-search-panel [visible]="true" [width]="300" placeholder="Search..."></dxo-search-panel>
            <dxo-export [enabled]="true" [allowExportSelectedData]="true" fileName="NewFileName">
            </dxo-export>
            <!-- <dxo-selection [selectAllMode]="allMode" [showCheckBoxesMode]="checkBoxesMode" mode="multiple">Check
        </dxo-selection> -->
            <dxo-paging [pageSize]="10"></dxo-paging>
            <dxo-pager [showPageSizeSelector]="true" [showInfo]="true" [allowedPageSizes]="[5, 10, 20]"></dxo-pager>
            <!-- <dxo-filter-row [visible]="true"></dxo-filter-row> -->
            <dxi-column caption="S.No" [width]="50" cellTemplate="SerialNoTemplate" alignment="center"></dxi-column>
            <div *dxTemplate="let data of 'SerialNoTemplate'">
                {{data.row.rowIndex + 1}}
            </div>
            <dxi-column caption="Download File" [width]="110" cellTemplate="download" cssClass="cell-highlighted" icon="download">
                        <!-- <dxi-button class="fa fa-exclamation" aria-hidden="true" icon="download" hint="Download"></dxi-button>  -->
            </dxi-column>
            <dxi-column dataField="fileNo" caption="File No" [width]="200"></dxi-column>
            <dxi-column   dataField="downloads" caption="Downloads" [width]="100" alignment="center"></dxi-column>
            <dxi-column dataField="fileName" caption="File Name" [width]="220"></dxi-column>
            <dxi-column dataField="userRefId" caption="User Ref No" [width]="150"></dxi-column>
            <dxi-column dataField="clientName" caption="Client Name" [width]="150"></dxi-column>
            <dxi-column dataField="userName" caption="Uploaded Admin" [width]="150"></dxi-column>
            <dxi-column dataField="fileType" caption="File Type" [width]="150"></dxi-column>
            <dxi-column dataField="createdDate" caption="Uploaded Date" [width]="150"></dxi-column>
        </dx-data-grid>

        
    
    </div>
</section>